import { FaApple, FaGooglePlay } from "react-icons/fa";
import { APP_STORE_URL, GOOGLE_PLAY_URL } from "./storeLinks";
import StoreDownloadButton from "./StoreDownloadButton";

const StoreBadges = ({ className = "", size = "medium" }) => {
    const isSmall = size === "small";

    return (
        <div className={`flex flex-wrap ${isSmall ? "gap-2" : "gap-4"} ${className}`}>
            <StoreDownloadButton
                href={APP_STORE_URL}
                Icon={FaApple}
                iconSize={isSmall ? 20 : 26}
                size={size}
                storeLabel="Télécharger sur"
                storeName="App Store"
                ariaLabel="Télécharger PretUp sur l'App Store"
                className={isSmall ? "" : "min-w-[170px]"}
            />
            <StoreDownloadButton
                href={GOOGLE_PLAY_URL}
                Icon={FaGooglePlay}
                iconSize={isSmall ? 18 : 24}
                size={size}
                storeLabel="Disponible sur"
                storeName="Google Play"
                ariaLabel="Télécharger PretUp sur Google Play"
                className={isSmall ? "" : "min-w-[170px]"}
            />
        </div>
    );
};

export default StoreBadges;
